import store from "./../store";
export const editInvoiceStatus = async (invoiceId, status) => {
    const changeDocStatus = {
        "docstatus": status
    };
    const response = await fetch(`${store.state.erp_api_url}api/resource/Sales Invoice/${invoiceId}`, {
        method: 'PUT',
        headers: {
            'Authorization': `${store.state.authorization_token}`
        },
        body: JSON.stringify(changeDocStatus)
    });
};
export const getPaymentByInvoice = async (invoiceId) => {
    const response = await fetch(
        `${store.state.erp_api_url}api/resource/Payment%20Entry?fields=["*"]&filters=[["Payment Entry Reference", "reference_name","=","${invoiceId}"]]`, {
            method: 'GET',
            headers: {
                'Authorization': `${store.state.authorization_token}`
            }
        }
    );
    const payments = await response.json();
    return payments.data;
};
export const getPaymentDetailByInvoiceId = async (invoiceId) => {
    const response = await fetch(`${store.state.erp_api_url}api/resource/PaymentDetail?fields=["*"]&filters=[["invoiceid", "=", "${invoiceId}"]]`, {
        method: 'GET',
        headers: {
            'Authorization': `${store.state.authorization_token}`
        },
    });
    const paymentDetails = await response.json();
    return paymentDetails.data;
};
export const editPayments = async (invoiceId, paymentId, paidAmount,paymentMode) => {
    const editPaymentData = {
        references: [{
            "reference_doctype": "Sales Invoice",
            reference_name: invoiceId,
            allocated_amount: parseFloat(paidAmount)
        }],
        mode_of_payment: paymentMode,
        received_amount: parseFloat(paidAmount),
        paid_amount: parseFloat(paidAmount),
        paid_to: `${paymentMode} - TCD`,
        paid_to_account_currency: "PKR"
    };
    // console.log({editPaymentData});
    try {
        const response = await fetch(`${store.state.erp_api_url}api/resource/Payment%20Entry/${paymentId}`, {
            method: 'PUT',
            headers: {
                'Authorization': `${store.state.authorization_token}`
            },
            body: JSON.stringify(editPaymentData)
        })
    } catch (error) {
        console.error("Error While Editing Payments", error);
    }
};
export const editPaymentDetails = async (invoiceId, paymentDetailId) => {
    const editPaymentData = {
        "invoiceid": invoiceId
    };

    try {
        const response = await fetch(`${store.state.erp_api_url}api/resource/PaymentDetail/${paymentDetailId}`, {
            method: 'PUT',
            headers: {
                'Authorization': `${store.state.authorization_token}`
            },
            body: JSON.stringify(editPaymentData)
        })
    } catch (error) {
        console.error("Error While Editing Payments", error);
    }
};
export const addInvoice = async (invoiceData) => {
    try {
        const createInvoiceResponse = await fetch(`${store.state.erp_api_url}api/resource/Sales Invoice`, {
            method: 'POST',
            headers: {
                'Authorization': `${store.state.authorization_token}`,
            },
            body: JSON.stringify(invoiceData)
        })
        const response = await createInvoiceResponse.json();
        return response;
    } catch (error) {
        console.error('Error fetching courses:', error);
    } 
};
export const createPayment = async (paymentData) => {
    try{
        const paymentResponse = await fetch(`${store.state.erp_api_url}api/resource/Payment%20Entry`, {
            method: 'POST',
            headers: {
                'Authorization': `${store.state.authorization_token}`,
            },
            body: JSON.stringify(paymentData)
        });
        return await paymentResponse.json();
    }catch(error){
        console.error(error);
    }
};
export const createPaymentDetail = async (paymentDetail) => {
    try {
        const response = await fetch(`${store.state.erp_api_url}api/resource/PaymentDetail`, {
            method: 'POST',
            headers: {
                'Authorization': `${store.state.authorization_token}`
            },
            body: JSON.stringify(paymentDetail)
        });
        return response.json();

    } catch (error) {
        console.error("Error Creating Payment Detail", error);
    }
};
export const getPaymentDetail = async (paymentId) => {
    try{
        const response= await fetch(`${store.state.erp_api_url}api/resource/PaymentDetail?fields=["*"]&filters=[["paymentid", "=", "${paymentId}"]]`,{
            method:'GET',
            headers:{
                'Authorization':`${store.state.authorization_token}`
            }
        });
        const paymentDetail = await response.json();
        return paymentDetail;
    }catch(error){
        console.error(error);
    }
};
export const getModesOfPayment = async () => {
     try{
        const response = await fetch(`${store.state.erp_api_url}api/resource/Mode%20of%20Payment?fields=["name","owner","creation","modified","modified_by","docstatus","mode_of_payment","enabled","type","doctype"]`,{
            method:'GET',
            headers:{
                'Authorization':`${store.state.authorization_token}`
            }
        });
        const paymentModes = await response.json();
        return paymentModes;
     }catch(error){
        console.error("Error Fetching Modes Of Payments.",error);
     }
};
export const getItemByItemName = async(itemId) => {
    const response = await fetch(`${store.state.erp_api_url}api/resource/Item/${itemId}`,{
        methos:'GET',
        headers:{
            'Authorization':`${store.state.authorization_token}`
        }
    });
    const responseData = await response.json();
    return responseData.data;
};